﻿import fetchResource from './resourceFetcher';
import typeFilter from './resourceTypeURLParser'

export const resourceSearch = {
    resourcesURL: '/resources/filter',
    workshopURL: '/workshops/filter',
    resourceType: typeFilter(),
    initiateSearchButton : document.querySelector('.resource-search__submit-button'),
    resourceSearchInput: document.querySelector('.resource-search__input-field'),
    initiateSeachButtonLoadingIcon : document.querySelector('.resource-search__loading-icon'),
    initiateSeachButtonChevron: document.querySelector('.resource-search__chevron-input-icon'),
    searchOverlaySearchTermDisplay : document.querySelector('.resource-search-overlay__search-term'),
    resourceOverlaySearchInput: document.querySelector('.resource-search-overlay__search-input'),
    initiateSearchOverlayButton : document.querySelector('.resource-search-overlay__submit-button'),
    searchOverlayResultContainer : document.querySelector('.resource-search-overlay__all-results'),
    searchOverlay: document.querySelector('.resource-search-overlay'),
    searchOverlayLoading: document.querySelector('.resource-search-overlay__loading-overlay'),
    closeSearchOverlayIcon : document.querySelector('.resource-search-overlay__close-icon'),

    init: function (resourceState) {
        //Are we on workshops?
        const isWorkshop = resourceState.page === 'workshop' ? true : false;
        //constants

        const that = this;
        //Attach event listener to resourceInput. When it's updated, update the resourceStateObject'
        this.resourceSearchInput.addEventListener('keyup', function (event) {
            if (event.keyCode === 13 && resourceState.search != '') {
                that.initialSearchLoadToggle({ isLoading: true });
                that.searchEvent(resourceState.search, "", isWorkshop);
            }
            else {
                resourceState.search = this.value;
            }
        });
        this.initiateSearchButton.addEventListener('click', function (event) {
            event.preventDefault();
            if (resourceState.search != '') {
                that.initialSearchLoadToggle({ isLoading: true });
                that.searchEvent(resourceState.search, "", isWorkshop);
            }
        });

        //Searching from the overlay
        this.resourceOverlaySearchInput.addEventListener('keyup', function (event) {
            if (event.keyCode === 13 && event.target.value != '') {
                //Let animation container show when searching from overlay
                that.searchOverlayLoading.classList.remove('resource-search-overlay__loading-overlay--hidden');
                that.searchEvent(resourceState.search, "", isWorkshop)
            }
            else {
                resourceState.search = this.value;
            }
        })
        this.initiateSearchOverlayButton.addEventListener('click', function (event) {
            event.preventDefault();
            if (resourceState.search != '') {
                //Let animation container show when searching from overlay
                that.searchOverlayLoading.classList.remove('resource-search-overlay__loading-overlay--hidden');
                that.searchEvent(resourceState.search, "", isWorkshop)
            }
        })

        //Close the overlay
        this.closeSearchOverlayIcon.addEventListener('click', function (event) {
            event.preventDefault();
            that.initialSearchLoadToggle({ isLoading: false });
            that.searchOverlay.classList.add('resource-search-overlay--closed');
            that.resourceSearchInput.value = '';
        })

    },


    bundleData(searchTerm) {
        return JSON.stringify({
            "types": this.resourceType,
            "topics": "",
            "search": searchTerm,
            "minimal": true
        })
    },


    initialSearchLoadToggle: function (loading) {
        if (loading.isLoading === true) {
            //disable button and add in hour glass icon to button
            this.resourceSearchInput.classList.add('disabled');
            this.initiateSearchButton.classList.add('disabled');
            this.initiateSeachButtonChevron.classList.add('d-none');
            this.initiateSeachButtonLoadingIcon.classList.remove('d-none');
        }
        else {
            //overlay is closing so enable button and add in original icon
            this.resourceSearchInput.classList.remove('disabled');
            this.initiateSearchButton.classList.remove('disabled');
            this.initiateSeachButtonChevron.classList.remove('d-none');
            this.initiateSeachButtonLoadingIcon.classList.add('d-none');
        }
    },

    toggleOverlay: function (state) {

    },

    overlaySearchLoadToggle: function () {

    }, 

    searchEvent: function (searchTerm, type, isWorkshop) {
        const url = isWorkshop === true ? this.workshopURL : this.resourcesURL;
        fetchResource(url, this.bundleData(searchTerm, type)).then(data => {
            this.displaySearchResults(data, searchTerm);
        })
    },

    displaySearchResults: function (data, searchTerm) {

        this.searchOverlaySearchTermDisplay.textContent = String(searchTerm);
        this.resourceOverlaySearchInput.value = String(searchTerm);
        this.searchOverlayResultContainer.innerHTML = data;
        this.highlightSearchTerm(searchTerm);
        this.searchOverlayLoading.classList.add('resource-search-overlay__loading-overlay--hidden');
        this.searchOverlay.classList.remove('resource-search-overlay--closed');
    },

    highlightSearchTerm: function (searchTerm) {
        const results = document.querySelectorAll('.resource-search-overlay__result-container');
        for (const result of results) {
            let heading = result.querySelector('.resource-search-overlay__result-link');
            let description = result.querySelector('.resource-search-overlay__result-description');
            const regex = new RegExp(searchTerm, 'gi');
            const replacedHeading = heading.textContent.replace(regex, function (str) {
                return `<span class="resource-search-overlay__search-highlight">${str}</span>`
            })
            const replacedDescription = description.textContent.replace(regex, function (str) {
                return `<span class="resource-search-overlay__search-highlight">${str}</span>`
            })
            heading.innerHTML = replacedHeading;
            description.innerHTML = replacedDescription;
        }
    }
}